// extracted by mini-css-extract-plugin
module.exports = {"root":"taLoaderBar_root__3eG7V","progress":"taLoaderBar_progress__3D2Zz"};